module.exports = __webpack_public_path__ + "jinjin.jpg?1ad086d90a3bf1fb87598f4401e474e6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/jinjin.jpg
// module id = 129
// module chunks = 0